import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

const TYPES = ["vehicle","resident","tenant","visitor"];

export default function Blacklist() {
  const { user } = useAuth();
  const [list, setList] = useState([]);
  const [form, setForm] = useState({ entity_type: "vehicle", plate_number: "", reason: "" });

  const load = () => api.get("/blacklist").then(r => setList(r.data));
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/blacklist", { ...form, plate_number: form.plate_number.toUpperCase(), property_id: user.property_id });
      toast.success("Added to blacklist");
      setForm({ entity_type: "vehicle", plate_number: "", reason: "" });
      load();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Failed");
    }
  };

  const remove = async (id) => {
    try { await api.delete(`/blacklist/${id}`); toast.success("Removed"); load(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Failed"); }
  };

  return (
    <div className="space-y-6">
      <header>
        <p className="text-xs font-mono uppercase tracking-[0.3em] text-zinc-500">Blacklist</p>
        <h1 className="font-heading text-4xl font-black tracking-tighter mt-1">Block list.</h1>
      </header>
      <Card className="bg-[#141414] border-zinc-800 p-6">
        <form onSubmit={submit} className="grid grid-cols-1 md:grid-cols-4 gap-3 items-end">
          <div>
            <Label className="text-xs font-mono uppercase tracking-widest text-zinc-500">Type</Label>
            <Select value={form.entity_type} onValueChange={(v) => setForm({ ...form, entity_type: v })}>
              <SelectTrigger className="bg-[#0F0F10] border-zinc-800"><SelectValue /></SelectTrigger>
              <SelectContent>{TYPES.map(t => <SelectItem key={t} value={t}>{t}</SelectItem>)}</SelectContent>
            </Select>
          </div>
          <div>
            <Label className="text-xs font-mono uppercase tracking-widest text-zinc-500">Plate</Label>
            <Input value={form.plate_number} onChange={(e) => setForm({ ...form, plate_number: e.target.value.toUpperCase() })} className="bg-[#0F0F10] border-zinc-800 font-mono" />
          </div>
          <div className="md:col-span-2 grid grid-cols-3 gap-2">
            <div className="col-span-2">
              <Label className="text-xs font-mono uppercase tracking-widest text-zinc-500">Reason</Label>
              <Input value={form.reason} onChange={(e) => setForm({ ...form, reason: e.target.value })} required className="bg-[#0F0F10] border-zinc-800" />
            </div>
            <Button type="submit" className="bg-red-500 text-white hover:bg-red-400 self-end" data-testid="blacklist-add-button">Blacklist</Button>
          </div>
        </form>
      </Card>
      <Card className="bg-[#141414] border-zinc-800 p-6 overflow-x-auto">
        <table className="w-full text-sm">
          <thead><tr className="text-left text-zinc-500 text-xs font-mono uppercase">
            <th className="py-2 pr-4">When</th><th className="py-2 pr-4">Type</th>
            <th className="py-2 pr-4">Plate</th><th className="py-2 pr-4">Reason</th><th></th>
          </tr></thead>
          <tbody className="divide-y divide-zinc-800">
            {list.map(b => (
              <tr key={b.id}>
                <td className="py-2 pr-4 text-zinc-400 text-xs">{new Date(b.created_at).toLocaleString()}</td>
                <td className="py-2 pr-4">{b.entity_type}</td>
                <td className="py-2 pr-4 font-mono">{b.plate_number || "—"}</td>
                <td className="py-2 pr-4 text-zinc-300">{b.reason}</td>
                <td className="py-2 pr-4 text-right">
                  <Button onClick={() => remove(b.id)} variant="outline" size="sm" className="border-zinc-700 bg-transparent">Remove</Button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
